// extracted by mini-css-extract-plugin
module.exports = {"c-banner-container":"_025a50318d--c-banner-container--Pht3z","content":"_025a50318d--content--zQYbn","img":"_025a50318d--img--IUHCV","text":"_025a50318d--text--KlRhx"};